<template>
  <v-dialog v-model="mn_dialog" scrollable max-width="900px" persistent>
    <v-form v-model="isValid" ref="form">
      <v-card>
        <v-toolbar color="white" fixed>
          <h3>{{ addNewLabel }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container dense>
            <v-row>
              <v-col cols="12" sm="4" md="5" lg="5">
                <v-text-field
                  v-model="nameMaster.name"
                  :label="$i18n.t('Name') + '*'"
                  :rules="validationrules.name"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="4" md="5" lg="5">
                <v-select
                  v-model="nameMaster.type"
                  :label="$i18n.t('Type') + '*'"
                  :rules="validationrules.type"
                  :items="nameTypes"
                  item-text="name"
                  item-value="value"
                  :disabled="type != null"
                  required
                ></v-select>
              </v-col>

              <v-col cols="12" sm="4" md="2" lg="2">
                <v-btn
                  color="success darken-1"
                  @click="save()"
                  :loading="loading"
                  :disabled="!isValid"
                  >Save</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-container dense>
          <v-simple-table dense>
            <thead class="thead">
              <tr>
                <th class="text-left">{{ $i18n.t("Name") }}</th>
                <th class="text-left">{{ $i18n.t("Action") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(na, index) in nameMasters" :key="index">
                <td>
                  <span v-if="!na.hideName">{{ na.name }}</span>
                  <v-btn
                    @click="na.hideName = true"
                    text
                    x-small
                    fab
                    color="grey"
                    v-if="!na.hideName && na.corp_id"
                    ><v-icon>mdi-pencil</v-icon></v-btn
                  >
                  <v-text-field
                    v-if="na.hideName"
                    v-model="na.name"
                    dense
                    @blur="onBlur(na)"
                    @change="edit(na)"
                  />
                </td>
                <td>
                  <v-row>
                    <v-col cols="2">
                      <v-btn
                        text
                        fab
                        x-small
                        color="green"
                        title="Select"
                        @click="selectName(na)"
                        :loading="na.loading"
                        ><v-icon>mdi-check</v-icon></v-btn
                      >
                    </v-col>

                    <v-col cols="2">
                      <z-confirm-button
                        text
                        fab
                        x-small
                        color="red lighten-2"
                        @click="deleteName(na)"
                        :message="$i18n.t('Sure ?')"
                        :loading="na.loading"
                        v-if="na.corp_id"
                      >
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </z-confirm-button>
                    </v-col>
                  </v-row>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-container>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doPost, doGet } from "@/store/common/module/apis";
import corpService from "@/store/common/module/CorpService";

@Component({
  name: "NameMasterCreate",
  props: {
    showDialog: {
      default: false,
    },
    type: {
      default: null,
    },
    addNewLabel: {
      default: "Name Master Create",
    },
  },
})
export default class NameMasterCreate extends Vue {
  name = "NameMasterCreate";
  isValid = true;
  nameMasterPOSO = {
    _id: null,
    name: "",
    type: this.type,
    corp_id: null,
  };
  nameMaster = Object.assign(this.nameMasterPOSO);
  nameMasters = [];
  mn_dialog = false;

  nameTypes = [
    { name: "Tariff Name", value: 1 },
    { name: "Vehicle Expense", value: 2 },
    { name: "Driver Expense", value: 3 },
    { name: "Insurance Provider", value: 4 },
    { name: "Permit Name", value: 5 },
    { name: "Material", value: 6 },
    { name: "Payment Mode", value: 7 },
    { name: "Fare Item", value: 8 },
    { name: "Discount Item", value: 9 },
    { name: "Truck Body Type", value: 10 },
    { name: "Fitness Issuing Authority", value: 11 },
    { name: "PUC Authority", value: 12 },
    { name: "Zone", value: 13 },
    { name: "Branch", value: 14 },
  ];

  @Watch("type")
  onTypeChange(type) {
    this.nameMaster.type = type;
    this.populateNameMasters();
  }

  async populateNameMasters() {
    await corpService.populateNameMasters(this.type);
    const nameMasters = corpService.nameMasters[this.type];

    if (nameMasters) {
      for (let i = 0; i < nameMasters.length; i++) {
        nameMasters[i].hideName = null;
        nameMasters[i].hardHide = null;
        nameMasters[i].loading = null;
      }
    }

    this.nameMasters = nameMasters;
  }

  onBlur(na) {
    if (!na.hardHide) {
      na.hideName = null;
    } else {
      na.hideName = true;
    }
  }

  async mounted() {
    this.populateNameMasters();
  }

  get loading() {
    return common.loading;
  }

  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
    type: [(v) => !!v || this.$i18n.t("Type is required")],
  };

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.mn_dialog = val;
  }

  closeDialog() {
    this.mn_dialog = false;
    this.$emit("select", null);
  }

  async save() {
    if (!this.nameMaster || !this.nameMaster.name) {
      common.setError("Name empty");
      return;
    }
    if (!this.nameMaster.type) {
      common.setError("Type empty");
      return;
    }

    try {
      common.setLoading(true);
      await doPost("/api/name/master/save", this.nameMaster);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      await corpService.repopulateNameMaster(this.type);
      this.populateNameMasters();
      this.nameMaster = this.nameMasterPOSO;
      this.nameMaster.name = null;
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async edit(_name) {
    if (!_name || !_name.name) {
      common.setError("Name empty");
      return;
    }
    if (!_name.type) {
      common.setError("Type empty");
      return;
    }

    try {
      common.setLoading(true);
      _name.loading = true;
      await doPost("/api/name/master/save", _name);
      common.setLoading(false);
      _name.loading = null;
      common.showMessage("Saved Successfully");
      await corpService.repopulateNameMaster(this.type);
      this.populateNameMasters();
      this.nameMaster = this.nameMasterPOSO;
    } catch (e) {
      _name.loading = null;
      _name.hideName = true;
      _name.hardHide = true;
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async deleteName(_name) {
    try {
      common.setLoading(true);
      _name.loading = true;
      await doGet("/api/name/master/" + _name._id + "/delete");
      common.setLoading(false);
      _name.loading = null;
      await corpService.repopulateNameMaster(this.type);
      this.populateNameMasters();
      common.showMessage("Deleted");
    } catch (e) {
      _name.loading = null;
      common.setLoading(false);
      common.setError(e);
    }
  }

  selectName(_name) {
    this.$emit("select", _name);
    this.mn_dialog = false;
  }
}
</script>
